if (!customElements.get("rr-header-account-icon")) {
  const accountCloseStyle = '.account__close{background-color:transparent!important;background-image:url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22m1%201%2014%2014M1%2015%2015%201%22%20stroke%3D%22white%22%20stroke-width%3D%221%22%2F%3E%3C%2Fsvg%3E")!important;background-position:center!important;background-repeat:no-repeat!important;background-size:15.4px 15.4px!important;border-color:transparent!important;border-radius:0!important;box-shadow:none!important;color:#ffffff!important;opacity:0.75!important;transition:opacity 0.2s ease!important}.account__close svg{visibility:hidden!important}@media(hover:hover) and (pointer:fine){.account__close:hover{opacity:1!important}}.account__close:focus-visible{outline:2px solid #ffffff!important;outline-offset:2px}@media(prefers-reduced-motion:reduce){.account__close{transition:none!important}}';
  const moreWaysStyle = '.login-form__show-logins-button{display:none!important}.login-form__email-form.login-form__email-form--hidden{display:flex!important}';
  class RRHeaderAccountIcon extends HTMLElement {
    #account = null;
    #animationFrame = null;
    #connectionAttempts = 0;
    #observer = null;
    #shadowRoot = null;
    #loginRoots = new Map();
    #shopCards = new Map();
    #refreshLogin = () => this.#styleLoginForms();

    connectedCallback() {
      this.#connectionAttempts = 0;
      this.#connectToAccount();
    }

    disconnectedCallback() {
      if (this.#animationFrame !== null) {
        cancelAnimationFrame(this.#animationFrame);
        this.#animationFrame = null;
      }

      this.#observer?.disconnect();
      this.#observer = null;
      this.#account?.removeEventListener("open", this.#refreshLogin);
      for (const observer of this.#loginRoots.values()) observer.disconnect();
      this.#loginRoots.clear();
      for (const [shop, state] of this.#shopCards) this.#releaseShopCard(shop, state);
      this.#shopCards.clear();
      this.#shadowRoot = null;
      this.#account = null;
      this.removeAttribute("data-signed-in");
    }

    #connectToAccount() {
      if (!this.isConnected) return;

      this.#account = this.parentElement?.querySelector(":scope > shopify-account") ?? null;
      const shadowRoot = this.#account?.shadowRoot;

      if (!shadowRoot) {
        this.#connectionAttempts += 1;

        if (this.#connectionAttempts < 120) {
          this.#animationFrame = requestAnimationFrame(() => this.#connectToAccount());
        }

        return;
      }

      this.#animationFrame = null;
      this.#shadowRoot = shadowRoot;
      this.#hideNativeSignedInAvatar();

      this.#observer = new MutationObserver(() => this.#hideNativeSignedInAvatar());
      this.#observer.observe(shadowRoot, { childList: true, subtree: true });
      this.#account.addEventListener("open", this.#refreshLogin);
      const account = this.#account;
      for (const name of ["shopify-login-form", "shop-login"]) {
        customElements.whenDefined(name).then(() => {
          if (this.isConnected && this.#account === account) this.#styleLoginForms();
        });
      }
    }

    #hideNativeSignedInAvatar() {
      if (!this.#shadowRoot) return;

      const heading = this.#shadowRoot.querySelector(".account__heading");
      const signedOutHeading = this.getAttribute("signed-out-heading");
      if (signedOutHeading && heading?.textContent.trim() === "Sign in or create account") {
        heading.textContent = signedOutHeading;
      }
      const greeting = this.getAttribute("signed-in-greeting");
      const nativeGreeting = heading?.textContent.trim();
      if (greeting && nativeGreeting?.startsWith("Hi, ") && nativeGreeting.length > 4) {
        heading.textContent = greeting.replace("__RR_FIRST_NAME__", () => nativeGreeting.slice(4));
      }

      if (this.hasAttribute("signed-in-only")) {
        this.toggleAttribute("data-signed-in", Boolean(this.#shadowRoot.querySelector(".account-button__avatar")));
      }

      let style = this.#shadowRoot.getElementById("rr-header-account-avatar-style");
      if (!style) {
        style = document.createElement("style");
        style.id = "rr-header-account-avatar-style";
        this.#shadowRoot.append(style);
      }
      const compactMenu = this.hasAttribute("signed-in-only") && this.hasAttribute("data-signed-in");
      const css = ':host{--shopify-account-font-body:"Raiman Rocks",serif!important;--shopify-account-font-heading:"Raiman Rocks",serif!important}.account-button__avatar{visibility:hidden!important}@media(hover:hover){a.button.outline:is([href*="/orders"],[href*="/profile"]):hover{background-color:#ffffff!important;color:#000000!important}}a.button.outline:is([href*="/orders"],[href*="/profile"]){font-family:"Raiman Rocks",serif!important;font-size:12px!important;font-weight:500!important;text-transform:uppercase!important;letter-spacing:0.08em!important;font-kerning:normal}' + (compactMenu
        ? "@media(min-width:751px){.dialog{width:max-content!important;max-width:min(360px,calc(100vw - 40px))!important;inset-inline-start:max(0px,calc(var(--rr-drawer-navigation-left,var(--container-gutter,20px)) - 16px))!important}.account__header-content{padding-inline-start:0}.account__menu-items>.stack-inline{flex-direction:column}}"
        : "");
      if (style.textContent !== css + moreWaysStyle + accountCloseStyle) style.textContent = css + moreWaysStyle + accountCloseStyle;
      this.#styleLoginForms();
    }

    #styleLoginForms() {
      if (!this.#shadowRoot) return;
      const forms = Array.from(this.#shadowRoot.querySelectorAll("shopify-login-form, shop-login.shop-login"));
      this.#prepareShopCards(forms);
      const roots = new Set(forms.map(form => form.shadowRoot).filter(Boolean));
      for (const [root, observer] of this.#loginRoots) {
        if (!roots.has(root)) {
          observer.disconnect();
          this.#loginRoots.delete(root);
        }
      }
      for (const root of roots) {
        let style = root.getElementById("rr-account-login-style");
        if (!style) {
          style = document.createElement("style");
          style.id = "rr-account-login-style";
          root.append(style);
        }
        const css = ':host{--shopify-login-form-font-body:"Raiman Rocks",serif!important}.login-form__social-login-button.shop-login,button.bg-purple-primary{background-color:#000000!important;color:#ffffff!important}.login-form__social-login-button,button.bg-purple-primary{font-family:"Raiman Rocks",serif!important}@media(hover:hover){.login-form__social-login-button.shop-login:hover,button.bg-purple-primary:hover{background-color:#ffffff!important;color:#000000!important}button.bg-purple-primary:hover .text-white{color:#000000!important}}' + '.login-form__email-input{background-color:#000000!important;color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;caret-color:#ffffff!important}.login-form__email-input:is(:autofill,:-webkit-autofill){box-shadow:0 0 0 1000px #000000 inset!important}' + '.login-form__email-input::placeholder{-webkit-text-fill-color:transparent!important;color:transparent!important}' + '.login-form__email-submit{background-color:#000000!important;color:#ffffff!important;border:1px solid #666666!important}@media(hover:hover){.login-form__email-submit:not(:disabled):hover{background-color:#ffffff!important;color:#000000!important;border-color:#ffffff!important}}.login-form__marketing-consent-visual{background-color:#000000!important;box-shadow:0 0 0 1px #888888 inset!important}.login-form__marketing-consent-checkbox:checked + .login-form__marketing-consent-visual{background-color:#ffffff!important;box-shadow:0 0 0 1px #ffffff inset!important}.login-form__marketing-consent-icon{color:#000000!important}.login-form__email-submit:focus-visible,.login-form__marketing-consent-checkbox:focus-visible + .login-form__marketing-consent-visual{outline:2px solid #ffffff!important;outline-offset:2px;box-shadow:none!important}' + '.bg-purple-primary:not(button){background-color:#000000!important;color:#ffffff!important}button.bg-purple-primary{--tw-ring-color:#000000!important}button.bg-purple-primary:active{background-color:#000000!important;color:#ffffff!important}button.bg-purple-primary:active .text-white{color:#ffffff!important}button.bg-purple-primary:focus-visible{outline:2px solid #ffffff!important;outline-offset:2px}' + 'button.bg-purple-primary .font-sans{font-family:"Raiman Rocks",serif!important}.login-form__marketing-consent-label{font-size:var(--font-size-sm)!important}' + 'button.bg-purple-primary .font-sans{text-transform:uppercase!important;font-size:12px!important;letter-spacing:0.08em!important;font-kerning:normal;line-height:15px!important;align-items:center!important}' + 'button.bg-purple-primary .font-sans{position:relative;top:2px;gap:4.788px!important;transform:translateY(-1px)}button.bg-purple-primary .font-sans > svg{position:relative;top:-2px}' + '.login-form__marketing-consent{interpolate-size:allow-keywords;height:auto;max-height:20em;opacity:1;visibility:visible;overflow:hidden;transition:height 300ms ease,max-height 300ms ease,opacity 250ms ease,margin 300ms ease,visibility 0s}.login-form__root:has(.login-form__email-input:placeholder-shown):not(:has(.login-form__email-input:is(:autofill,:-webkit-autofill))) > .login-form__marketing-consent{height:0;max-height:0;min-height:0;opacity:0;visibility:hidden;pointer-events:none;margin-block:-12px 0;transition:height 300ms ease,max-height 300ms ease,opacity 200ms ease,margin 300ms ease,visibility 0s 300ms}@media(prefers-reduced-motion:reduce){.login-form__marketing-consent{transition:none!important}}' + '[data-testid="login-recognition"]{background-color:#000000!important;color:#ffffff!important}[data-testid="recognition-iframe-skeleton"] .bg-grayscale-l2{background-color:#333333!important}[data-testid="animated-shop-logo"] .text-purple-primary{color:#ffffff!important}[data-testid="recognition-iframe-wrapper"] > .bg-gradient-to-r{background-image:linear-gradient(to right,transparent,#000000)!important}';
        if (style.textContent !== css + moreWaysStyle) style.textContent = css + moreWaysStyle;
        if (!this.#loginRoots.has(root)) {
          const observer = new MutationObserver(this.#refreshLogin);
          observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-visible", "role"] });
          this.#loginRoots.set(root, observer);
        }
      }
    }

    #releaseShopCard(shop, state) {
      if (state.timer !== null) clearTimeout(state.timer);
      if (state.anchor?.parentNode) state.anchor.replaceWith(shop);
      shop.removeEventListener("dismiss", state.keepExpanded, true);
    }

    #prepareShopCards(forms) {
      const shops = new Set(forms.filter(form => form.localName === "shop-login" && form.getAttribute("flow-version") === "account_menu"));
      for (const [shop, state] of this.#shopCards) {
        if (!shops.has(shop) && !state.anchor?.parentNode) {
          this.#releaseShopCard(shop, state);
          this.#shopCards.delete(shop);
        }
      }
      for (const shop of shops) {
        let state = this.#shopCards.get(shop);
        if (!state) {
          const keepExpanded = event => {
            const recognition = shop.shadowRoot?.querySelector('[data-testid="login-recognition"]');
            if (event.target === shop && recognition?.getAttribute("data-visible") === "true" && recognition.getAttribute("role") !== "button") {
              event.stopImmediatePropagation();
            }
          };
          state = { keepExpanded, anchor: null, timer: null, remounted: false };
          this.#shopCards.set(shop, state);
          shop.addEventListener("dismiss", keepExpanded, true);
          shop.setAttribute("presentation-mode", "card");
        }
        const recognition = shop.shadowRoot?.querySelector('[data-testid="login-recognition"]');
        if (state.remounted || recognition?.getAttribute("data-visible") !== "true" || recognition.getAttribute("role") !== "button") continue;
        state.remounted = true;
        shop.setAttribute("presentation-mode", "card");
        const account = this.#account;
        const anchor = document.createComment("rr-shop-card-remount");
        state.anchor = anchor;
        shop.replaceWith(anchor);
        state.timer = setTimeout(() => {
          state.timer = null;
          if (this.isConnected && this.#account === account && anchor.parentNode && this.#shadowRoot.contains(anchor)) {
            anchor.replaceWith(shop);
            state.anchor = null;
            this.#styleLoginForms();
          } else {
            this.#releaseShopCard(shop, state);
            this.#shopCards.delete(shop);
          }
        }, 0);
      }
    }
  }

  customElements.define("rr-header-account-icon", RRHeaderAccountIcon);
}
